/* eslint-disable no-underscore-dangle */
import has from 'lodash/has';

class Chartbeat {
  /**
   *
   * @param {string} section
   */
  constructor({ section }) {
    this.section = section.toLowerCase();
  }

  static getDomain() {
    if (window.location.host.includes('dev')) {
      return 'apps-dev.bostonglobe.com';
    }
    if (window.location.host.includes('localhost')) {
      return 'localhost.bostonglobe.com';
    }
    return 'bostonglobe.com';
  }

  // All of the operations are synchronous, so the async promise will resolve immediately.
  async load() {
    window._sf_startpt = (new Date()).getTime();
    window._sf_async_config = { uid: 8544, domain: Chartbeat.getDomain() };
    window._sf_async_config.path = window.location.pathname;

    // Section and Author tagging
    window._sf_async_config.sections = this.section;
    window._sf_async_config.authors = 'infographic';
  }

  // eslint-disable-next-line class-methods-use-this
  initializeMeterObserver() {
    if (has(window, 'meterObject.observationController.addEventObserver')) {
      window.meterObject.observationController.addEventObserver(
        'userStateChange',
        Chartbeat.loadChartbeat,
      );
    }
  }

  static loadChartbeat(userInfo) {
    window._sf_endpt = (new Date()).getTime();
    window._cbq = window._cbq || [];

    if (has(window, 'meterObject.helperFunctions.getChartbeatUserStatus')) {
      const userStatus = window.meterObject.helperFunctions.getChartbeatUserStatus(userInfo);
      window._cbq.push(['_acct', userStatus]);
    }

    const base = (document.location.protocol === 'https:') ? 'https://s3.amazonaws.com/' : 'http://';

    const scriptElement = document.createElement('script');
    scriptElement.setAttribute('language', 'javascript');
    scriptElement.setAttribute('type', 'text/javascript');
    scriptElement.setAttribute('src', `${base}static.chartbeat.com/js/chartbeat.js`);

    document.body.appendChild(scriptElement);
  }
}

export default Chartbeat;
